import React from "react";
import DataGrid, {
  Column,
  Selection,
  FilterRow,
  Paging,
  Pager,
  Toolbar,
  Item,
  Lookup,
} from "devextreme-react/data-grid";
import { formatMessage } from "devextreme/localization";
import FileUploader from "devextreme-react/file-uploader";
import notify from "devextreme/ui/notify";
import { Popup, ToolbarItem } from "devextreme-react/popup";

import { useScreenSize } from "../../../utils/media-query";

import ToolbarBefore from "./ToolbarBefore";
import ToolbarAfter from "./ToolbarAfter";
import {
  RequestStatus,
  changeDisplayedName,
  ApprovalStatus,
  generateBlobLink,
  axios,
} from "../../../common";
import PopupConfig from "../../../common/popup";

export default function TransactionAdjustmentTableList({
  middleware,
  dataGrid,
  renderActions,
  dataSource,
  handleChangeSelectBox,
  filter,
  setFilter,
  employeeOid,
  setEmployeeOid,
  user,
  employee,
  setIsLoading,
}) {
  const { isXSmall, isSmall } = useScreenSize();
  const [file, setFile] = React.useState(null);
  const [clicked, setClicked] = React.useState(false);
  const [errorPath, setErrorPath] = React.useState(null);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();

  const handleImportExcel = async (e) => {
    if (clicked) return;
    setClicked(true);
    setIsLoading(true);
    try {
      if (!file) {
        notify("Please select file to import", "error", 3000);
        setIsLoading(false);
        setClicked(false);
        return;
      }
      const formData = new FormData();
      formData.append("fileName", file);
      // formData.append("EmployeeOid", user?.EmployeeOid);
      const { data, headers } = await axios.post(
        "Transaction/ImportFile",
        formData,
        {
          responseType: "arraybuffer",
        }
      );
      setClicked(false);
      if (data.byteLength === 2) {
        notify("Import thành công", "success", 3000);
        handleChangeSelectBox();
        setIsLoading(false);
        handleClosePopup();
        return;
      }
      const relsUrl = generateBlobLink(data, headers["content-type"]);

      setErrorPath(relsUrl);
      notify(`Import đơn đăng ký không thành công`, "error", 3000);
      setIsLoading(false);
      // handleClosePopup()
      handleChangeSelectBox();
    } catch (error) {
      var enc = new TextDecoder("utf-8");
      var arr = enc.decode(error.response.data);
      setIsLoading(false);
      notify(JSON.parse(arr).message, "error", 3000);
      setClicked(false);
    }

    // setOvertime(data.value);
  };
  const clearPopup = () => {
    setFile(null);
    setErrorPath(null);
    handleClosePopup();
    setClicked(false);
  };
  const renderViewPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={clearPopup}
        title={formatMessage("PopupTitle")}
        showTitle={true}
        width={isSmall || isXSmall ? "100%" : "550px"}
        height={isSmall || isXSmall ? "400px" : "400px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <FileUploader
          selectButtonText="Select file"
          labelText=""
          accept=".xlsx, .xls"
          maxFileSize={5000000}
          uploadMode="useForm"
          onValueChanged={(e) => {
            // check file size and type
            if (e.value.length > 0) {
              if (e.value[0].size > 5000000) {
                notify("File size must be less than 5MB", "error", 3000);
                return;
              }
              if (
                e.value[0].type !==
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
                e.value[0].type !== "application/vnd.ms-excel"
              ) {
                notify("File type must be .xlsx or .xls", "error", 3000);
                return;
              }

              setFile(e.value[0]);
            }
          }}
        />
        {errorPath && (
          <div style={{ color: "red", marginTop: "10px" }}>
            <a href={errorPath} download>
              Download Error File
            </a>
          </div>
        )}
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleImportExcel}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={clearPopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };
  return (
    <>
      {popupConfig.popupVisible && renderViewPopup()}
      <DataGrid
        id="gridContainer"
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        onCellPrepared={(e) => {
          if (e.rowType === "data") {
            const {
              data,
              column: { dataField },
              cellElement,
            } = e;
            const isTimeInOrOut =
              dataField === "TimeIn" || dataField === "TimeOut";
            const isWorkingDay = dataField === "WorkingDay";
            // get data AdjustmentTimeIn, AdjustmentTimeOut 
            const isTimeInOrOutAdjustment = data.AdjustmentTimeIn || data.AdjustmentTimeOut

             

            if (isTimeInOrOut && !data[dataField] ) {
              cellElement.style.backgroundColor = isTimeInOrOutAdjustment ? "#3CAEA3" : "#F37B8D";
            }  
            if (isWorkingDay && (!data.TimeIn || !data.TimeOut)) {
              cellElement.style.color = isTimeInOrOutAdjustment ? "#3CAEA3" : "#F37B8D";
            }
          }
        }}
        allowColumnResizing={true}
        columnHidingEnabled={true}
        ref={(e) => {
          dataGrid.current = e;
        }}
        dataSource={dataSource}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />

        {middleware && middleware.WriteState && (
          <Column
            caption={formatMessage("Action")}
            cellRender={renderActions}
            alignment="center"

          />
        )}
        <Column
          caption={formatMessage("WorkingDay")}
          dataField="WorkingDay"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("Shift")}
          dataField="Shift"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("ShiftTimeIn")}
          dataField="ShiftTimeIn"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("ShiftTimeOut")}
          dataField="ShiftTimeOut"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("TimeIn")}
          dataField="TimeIn"
          hidingPriority={isXSmall || isSmall ? 3 : false}

        />
        <Column
          caption={formatMessage("TimeOut")}
          dataField="TimeOut"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("AdjustmentTimeIn")}
          dataField="AdjustmentTimeIn"
          dataType="string"
        />
        <Column
          caption={formatMessage("AdjustmentTimeOut")}
          dataField="AdjustmentTimeOut"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        />
        {/* <Column
        caption={formatMessage("AdjustmentTimeInIsNextDay")}
        dataField="AdjTimeInIsNextDay"
        hidingPriority={isXSmall || isSmall ? 3 : false}
        dataType="boolean"
      />
      <Column
        caption={formatMessage("AdjustmentTimeOutIsNextDay")}
        dataField="AdjTimeOutIsNextDay"
        hidingPriority={isXSmall || isSmall ? 3 : false}
        dataType="boolean"
      /> */}
        {/* <Column
          caption={formatMessage("AdjustmentReason")}
          dataField="AdjustmentReason"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        >
          <Lookup
            dataSource={TransactionAdjustmentReason}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column> */}
        <Column
          caption={formatMessage("RequestStatus")}
          dataField="RequestStatus"
          hidingPriority={isXSmall || isSmall ? 4 : false}
          width={130}
        >
          <Lookup
            dataSource={RequestStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("Explain")}
          dataField="Explain"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("LastApprovalStatus")}
          dataField="ApprovalStatus"
          dataType="string"
          hidingPriority={isXSmall || isSmall ? 4 : false}
        >
          <Lookup
            dataSource={ApprovalStatus}
            displayExpr={changeDisplayedName()}
            valueExpr="id"
          />
        </Column>
        <Column
          caption={formatMessage("LastApprovalDate")}
          dataField="ApprovedDate"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={isXSmall || isSmall ? 3 : false}
        />
        <Column
          caption={formatMessage("FirstApprovalName")}
          dataField="FirstApprovalName"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("LastApprovalName")}
          dataField="LastApprovalName"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />
        <Column
          caption={formatMessage("LastApprovalComments")}
          dataField="ApprovalComments"
          hidingPriority={isXSmall || isSmall ? 5 : false}
        />

        <Toolbar className="datagrid-toolbar-actions">
          <Item
            location="before"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarBefore
              middleware={middleware}
              filter={filter}
              setFilter={setFilter}
              handleChangeSelectBox={handleChangeSelectBox}
              employeeOid={employeeOid}
              setEmployeeOid={setEmployeeOid}
              user={user}
              employee={employee}
            />
          </Item>
          <Item
            location="after"
            locateInMenu={isXSmall || isSmall ? "always" : "auto"}
            cssClass={"datagrid-toolbar-actions-dropdown"}
          >
            <ToolbarAfter
              middleware={middleware}
              dataGrid={dataGrid}
              handleOpenPopup={handleOpenPopup}
            />
          </Item>
        </Toolbar>
      </DataGrid>
    </>
  );
}
